import React from "react";
import { BsLinkedin, BsGithub } from "react-icons/bs";

const SocialMedia = () => {
  const url = "https://www.linkedin.com/in/eyüp-ensar-ezber-79a28a264/";
  return (
    <div className="app__social">
      <a href={url}>
        <div>
          <BsLinkedin />
        </div>
      </a>
      <a href="https://github.com/goldeneagle3">
        <div>
          <BsGithub />
        </div>
      </a>
    </div>
  );
};

export default SocialMedia;
